import React from "react";
import "../App.css";
import logo from "../assets/main.jpg";
import SiteNav from "../components/SiteNav";
import DealerResourceSummary from "../components/DealerResourceSummary";
import usePageMeta from "../hooks/usePageMeta";
import { DEALERSHIP } from "../data/dealership";

function Legal() {
  usePageMeta({
    title: `Findlay Chrysler (${DEALERSHIP.location}) - Legal Resources & Reporting`,
    description:
      `How to file complaints about ${DEALERSHIP.name} in ${DEALERSHIP.location}, including state contacts and dealer permit information.`,
  });

  return (
    <>
      <SiteNav />
      <div className="container">
        <div className="text-center mt-5 text-uppercase">
          <h1 className="h3">Legal Resources & Reporting</h1>
        </div>
      </div>
      <div className="container">
        <div className="text-center mt-5 mb-5 text-uppercase">
          <p className="lead">
            <strong>Documented concerns about Derrow Automotive</strong>
          </p>
          <a
            href={DEALERSHIP.website}
            target="_blank"
            rel="noreferrer"
          >
            Findlay Chrysler located at: {DEALERSHIP.address}
          </a>
          <p className="mt-2 mb-0">
            Sales, service, and parts phone: {DEALERSHIP.phone}
          </p>
        </div>
      </div>
      <div className="container">
        <img
          src={logo}
          style={{ padding: "0px 30px 0px 30px", maxWidth: 1200 }}
          className="rounded mx-auto d-block w-100"
          alt="Findlay Chrysler dealership exterior"
        />
      </div>
      <div className="container py-5">
        <div className="text-left">
          <DealerResourceSummary compact />
          <p>
            The information on this page is based on documented interactions with
            Derrow Automotive and Findlay Chrysler staff. These statements are
            shared with federal and state investigators to encourage accountability
            and transparent sales practices.
          </p>
          <p>
            If you have experienced similar issues, please consider filing a
            complaint and sharing supporting documentation. Quick state response
            helps build a clearer record of customer impact.
          </p>
          <ul>
            <li>
              File with the Ohio Attorney General:{" "}
              <a
                href="https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx"
                target="_blank"
                rel="noreferrer"
              >
                https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx
              </a>
            </li>
            <li>
              General AG office information:{" "}
              <a
                href="https://www.ohioattorneygeneral.gov/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.ohioattorneygeneral.gov/
              </a>
            </li>
            <li>
              Ohio DMV Commercial Licensing (dealer permit {DEALERSHIP.dealerPermit}). Include the
              permit number and as much detail as possible in your report.
            </li>
          </ul>
          
          <div className="container text-center d-grid mx-auto m-4">
            <a
              href="https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary active"
              type="button"
              id="cc"
              style={{ backgroundColor: "#0377fc !important" }}
            >
              SUPPORT US BY FILING A REPORT
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Legal;
